module.exports = __webpack_public_path__ + "img/1070891121.0569b115.jpg";